import { render, staticRenderFns } from "./PopUpShare.vue?vue&type=template&id=2f85854d&scoped=true&"
import script from "./PopUpShare.vue?vue&type=script&lang=js&"
export * from "./PopUpShare.vue?vue&type=script&lang=js&"
import style0 from "./PopUpShare.vue?vue&type=style&index=0&id=2f85854d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85854d",
  null
  
)

export default component.exports